import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Service
import SalesService from '../../services/salesService'

import { Replace } from '../../stores/concepts/actions'

const useConcepts = () => {
  const { concepts } = useSelector(state => state.concept_data)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const FindConcepts = async () => {
      setLoading(true)
      const res = await SalesService.GetAllConcepts()
      dispatch(Replace(res))
      setLoading(false)
    }

    if (concepts.length <= 0) { FindConcepts() }
  }, [concepts.length, dispatch])

  return {
    concepts,
    loading
  }
}

export default useConcepts
